<template>
  <div class="close-modal-btn" @click="closeModal">
    <IconBase iconColor="#111" viewBox="0 0 329.26933 329" width="100%" height="100%" strokeWidth="3px"><IconClose /> </IconBase>
  </div>
</template>

<script>
import IconBase from "../../../../src/components/IconBase.vue";
import IconClose from "../../../../src/components/SVG/IconClose.vue";

export default {
  name: "CloseModalButton",
  components: {
    IconBase,
    IconClose,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style>
.close-modal-btn {
  width: calc(14px / var(--widthResoRatio));
  height: calc(14px / var(--widthResoRatio));
  padding: calc(14px / var(--widthResoRatio));
  border-radius: 360px;
  cursor: pointer;
  position: absolute;
  top: calc(20px / var(--widthResoRatio));
  right: calc(20px / var(--widthResoRatio));
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-modal-btn:hover {
  background-color: hsla(0, 0%, 97.6%, 0.79);
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(169 169 169 / 10%) 0px 3px 6px, rgb(96 96 96 / 20%) 0px 9px 24px;
}
</style>
